import moment from "moment";

import { newId } from "utils/random";

import * as actionTypes from "../constants";

import type { AnyAction } from "redux";
import type { ThunkAction, ThunkDispatch } from "redux-thunk";
import type { ErrorDetails } from "../models";
import type { State } from "../reducers";

export const addMessageAction = (
  message: string,
  details?: string | null,
  type = "success",
  time?: number,
  closable?: boolean,
  id?: string,
) => ({
  payload: [
    {
      closable,
      details,
      error: message,
      id: id ?? newId(),
      time: time ?? moment.now(),
      type,
    },
  ],
  type: actionTypes.UI_ADD_ERRORS,
});

export const addErrorsAction =
  (errors: ErrorDetails[]): ThunkAction<void, State, unknown, AnyAction> =>
  (dispatch: ThunkDispatch<State, unknown, AnyAction>) => {
    dispatch(addErrors(errors));
  };

export const clearErrorsAction =
  (index?: number, type?: string): ThunkAction<void, State, unknown, AnyAction> =>
  (dispatch: ThunkDispatch<State, unknown, AnyAction>) => {
    dispatch(clearErrors(index, type));
  };

export const clearErrorByIdAction =
  (id: string): ThunkAction<void, State, unknown, AnyAction> =>
  (dispatch: ThunkDispatch<State, unknown, AnyAction>, getState: () => State) => {
    const currentErrors = getState().ui.errors;
    const index = currentErrors.findIndex((err: ErrorDetails) => err.id === id);
    if (index !== -1) {
      dispatch(clearErrors(index));
    }
  };

export const addErrors = (errors: ErrorDetails[]) => ({
  payload: errors,
  type: actionTypes.UI_ADD_ERRORS,
});

const clearErrors = (index?: number, type?: string) => ({
  payload: { index, type },
  type: actionTypes.UI_CLEAR_ERRORS,
});

export const showUnhandledErrorAction =
  (error?: ErrorDetails | null): ThunkAction<void, State, unknown, AnyAction> =>
  (dispatch: ThunkDispatch<State, unknown, AnyAction>) => {
    dispatch(showUnhandledError(error));
  };

const showUnhandledError = (error?: ErrorDetails | null) => ({
  payload: error,
  type: actionTypes.UI_ADD_ERRORS,
});
